import { render, staticRenderFns } from "./TvHistory.vue?vue&type=template&id=e1f1eacc&scoped=true&"
import script from "./TvHistory.vue?vue&type=script&lang=js&"
export * from "./TvHistory.vue?vue&type=script&lang=js&"
import style0 from "./TvHistory.vue?vue&type=style&index=0&id=e1f1eacc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f1eacc",
  null
  
)

export default component.exports